import GetLabel from 'foundation/js/getLabel'
import { useStore } from 'vuex'
import { computed, onMounted } from 'vue'
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export default {
    name: 'ProfileOverlay',
    setup() {
        const store = useStore()
        let first, last, close
        const userProfileId = computed(() => store.state.main.page_overlay_content_data.userProfileId)
        const userInformationUrl = computed(() => store.state.main.page_overlay_content_data.userInformationUrl)
        const frivilligOrdersUrl = computed(() => store.state.main.page_overlay_content_data.frivilligOrdersUrl)
        const frivilligUrl = computed(() => store.state.main.page_overlay_content_data.frivilligUrl)
        const cancerforumUrl = computed(() => store.state.main.page_overlay_content_data.cancerforumUrl)
        const stafetForLivetUrl = computed(() => store.state.main.page_overlay_content_data.stafetForLivetUrl)
        const logoutUrl = computed(() => store.state.main.page_overlay_content_data.logoutUrl)
        
        const fundraisingCampaigns = computed(() => store.state.fundraising.userProfileFundraisingCampaigns)
        const sflHoldkaptajnHold = computed(() => store.state.stafet.userProfileHoldkaptajnHold)
        const showSpinner = computed(()=> fundraisingCampaigns.value === null)
        
        const hasFrivilligOrder = computed(() => store.state.frivilligprofil.has_frivillig_order)
        const hasFrivilligProfile = computed(() => store.state.main.user_profile?.hasFrivilligProfile)
        const hasFrivilligNotification = computed(() => store.state.main.user_profile?.hasFrivilligNotification)
        const hasCancerforumProfile = computed(() => store.state.main.user_profile?.hasCancerforumProfile)
        const hasCancerforumNotification = computed(() => store.state.main.user_profile?.hasCancerforumNotification)
        const hasStafetForLivetProfile = computed(() => store.state.main.user_profile?.hasStafetForLivetProfile)


        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        onMounted(() => {
            store.dispatch('main/fetchUserProfile', userProfileId.value)
            store.dispatch('fundraising/getUserProfileFundraisingCampaigns', userProfileId.value)
            store.dispatch('stafet/getUserProfileHoldkaptajnHold', userProfileId.value)
            store.dispatch('frivilligprofil/getProfileHasFrivilligOrders', userProfileId.value)
            first = document.querySelector('.kb-profile-overlay__link[data-order="first"]')
            last = document.querySelector('.kb-profile-overlay__logout[data-order="last"]')
            close = document.querySelector('.kb-page-overlay__close')
            onTransitionendCallback({
                opening(){
                    close.focus()
                }
            }, { persistent: true })
        })

        return {
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: 'ProfileOverlay' }),
            hasFrivilligProfile,
            hasFrivilligNotification,
            hasFrivilligOrder,
            hasCancerforumProfile,
            hasCancerforumNotification,
            hasStafetForLivetProfile,
            fundraisingCampaigns,
            sflHoldkaptajnHold,
            userInformationUrl,
            frivilligOrdersUrl,
            frivilligUrl,
            cancerforumUrl,
            stafetForLivetUrl,
            logoutUrl,
            tabTrap,
            showSpinner,
        }
    }
}
